import { Box, Button, Group, TextInput, Text } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import React from 'react';
import TagList from './TagList';
import { theme } from '../consilitheme';

const CategorySelector = ({
  isEditMode,
  hasSource,
  newTopic,
  setNewTopic,
  addTopic,
  hasTopics,
  isComplete,
  handleEnableEdit,
  interest,
  removeTag,
  setTags,
}) => {
  return (
    <div>
      <Group align="flex-end" justify="space">
        <Box sx={{ flexGrow: 1 }} mt={theme.padding.md}>
          <Text size="md" fw={600}>
            Categories
          </Text>
          {isEditMode ? (
            <TextInput
              mt={theme.padding.xs}
              disabled={!isEditMode || !hasSource}
              value={newTopic}
              onChange={(e) => setNewTopic(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  addTopic();
                }
              }}
              placeholder="Add a category"
            />
          ) : (
            !hasTopics && (
              <Group justify="space-between">
                <Text size="sm" c="gray" mt={theme.padding.sm}>
                  Click edit to add a category and get started.
                </Text>
              </Group>
            )
          )}
        </Box>{' '}
        {!isComplete && !hasTopics && (
          <Button
            variant="outline"
            color={theme.colors.red[4]}
            radius="md"
            size="xs"
            right="16px"
            bottom="16px"
            pos="absolute"
            onClick={handleEnableEdit}
          >
            Incomplete
          </Button>
        )}
        {isEditMode && (
          <Button
            onClick={addTopic}
            style={{ background: theme.colors.blue[4] }}
          >
            <IconPlus />
          </Button>
        )}
      </Group>
      <Group justify="space-between">
        {hasTopics && (
          <Box mt={theme.padding.sm}>
            <TagList
              baseTags={interest.categories?.map((category) => category?.name)}
              activeTopics={interest.categories?.map(
                (category) => category?.name
              )}
              setActiveTopics={isEditMode ? setTags : undefined}
              removableHint={isEditMode}
              defaultOutline
              clickable={isEditMode}
              tagColor={theme.colors.purple[3]}
              tagType={'category'}
              removeTag={(tag, tagType) => removeTag(tag, tagType)}
              large
            />
          </Box>
        )}{' '}
        {!isComplete && hasTopics && (
          <Button
            variant="outline"
            color={theme.colors.red[4]}
            radius="md"
            size="xs"
            onClick={handleEnableEdit}
          >
            Incomplete
          </Button>
        )}
      </Group>
    </div>
  );
};

export default CategorySelector;
